import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Check, X } from '../../bravosIcons';
import type { PlanBuilderToastState } from '../hooks/useTrainerWorkoutPlanBuilderState';

export interface PlanBuilderToastProps {
  toast: PlanBuilderToastState;
  onDismiss: () => void;
  onUndo?: () => void;
  /** Lift above the fixed save bar when both are visible */
  aboveSaveBar?: boolean;
}

export function PlanBuilderToast({ toast, onDismiss, onUndo, aboveSaveBar }: PlanBuilderToastProps) {
  useEffect(() => {
    const t = window.setTimeout(onDismiss, 5000);
    return () => window.clearTimeout(t);
  }, [onDismiss]);

  const { action } = toast;
  const subtitle =
    action.type === 'paste' || action.type === 'error' ? action.subtitle : undefined;
  const showUndo = onUndo && action.type !== 'error' && action.type !== 'saved';

  return createPortal(
    <div
      className={`twp-toast twp-toast--visible${aboveSaveBar ? ' twp-toast--above-save-bar' : ''}`}
      role="status"
      aria-live="polite"
    >
      <span className="twp-toast-check" aria-hidden="true">
        <Check size={15} strokeWidth={2.6} />
      </span>
      <div className="twp-toast-txt">
        <strong>{action.title}</strong>
        {subtitle ? <span>{subtitle}</span> : null}
      </div>
      {showUndo ? (
        <button type="button" className="twp-toast-undo" onClick={onUndo}>
          Undo
        </button>
      ) : null}
      <button type="button" className="twp-toast-x" aria-label="Dismiss" onClick={onDismiss}>
        <X size={14} strokeWidth={2} />
      </button>
    </div>,
    document.body,
  );
}
